import { useState, useEffect } from "react";
import Buttons from "../../../components/ui/button/Buttons";
import { useAddCRUDCategoryMutation, useEditCRUDCategoryMutation, useLazyDeleteCRUDCategoryByIdQuery, useLazyGetAllCRUDCategoryListQuery } from "../../../app/services/Crud/crudApi";
import SwalAlert from "../../../services/swalService/SwalService";
import Select from "react-select";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";
import NoRecordFound from "../../../components/ui/noRecordFound/NoRecordFound";

const categoryOptions = [
  { label: "Product", value: "Product" },
  { label: "Service", value: "Service" }
];
const subCategoryOptions = [
  { label: "L1", value: "L1" },
  { label: "L2", value: "L2" },
  { label: "L3", value: "L3" }
];
// const categoryOptions = ["Product", "Service"];
// const subCategoryOptions = ["L1", "L2", "L3"];
const categoryMap = { Product: 1, Service: 2 };
const subCategoryMap = { L1: 1, L2: 2, L3: 3 };

const CRUDCategoryList = () => {
  const [dataSource, setDataSource] = useState([]);
  const { error, success, confirm } = SwalAlert();
  const [isAdding, setIsAdding] = useState(false);
  const [getAllCRUDCategoryList, { data: crudCategoryListData, isLoading: isCrudCategoryLoading }] = useLazyGetAllCRUDCategoryListQuery();
  const [addCRUDCategory, { data: addCRUDCategoryData, isLoading: addCRUDCategoryLoading, error: addCRUDCategoryError }] = useAddCRUDCategoryMutation();
  const [editCRUDCategory, { data: editCRUDCategoryData, isLoading: editCRUDCategoryLoading, error: editCRUDCategoryError }] = useEditCRUDCategoryMutation();
  const [deleteCRUDCategoryById, { isLoading: isLoadingdeleteCRUDCategoryById, data: deleteCRUDCategoryByIdResponse, }] = useLazyDeleteCRUDCategoryByIdQuery()

  useEffect(() => {
    getAllCRUDCategoryList();
  }, []);

  useEffect(() => {
    if (!addCRUDCategoryLoading && addCRUDCategoryData) {

      if(addCRUDCategoryData.hasError){
        error(addCRUDCategoryData.errorMessage);
        setDataSource((prev) =>
          prev.filter((item) => !item.isNew)
        );
      }else{
        success("CRUD Category added successfully.");
      }
      getAllCRUDCategoryList();
      setIsAdding(false);
    }
  }, [addCRUDCategoryLoading, addCRUDCategoryData]);

  useEffect(() => {
    if (!editCRUDCategoryLoading && editCRUDCategoryData) {
  
      if(editCRUDCategoryData.hasError){
        error(editCRUDCategoryData.errorMessage);

        setDataSource((prev) =>
        prev.map((item) =>
          item.id === editCRUDCategoryData.keyId
            ? {
                ...item.originalRow,
                isEditing: false
              }
            : item
        )
      );
      }else{
        success("CRUD Category updated successfully.");
      }
      getAllCRUDCategoryList();
    }
  }, [editCRUDCategoryLoading, editCRUDCategoryData]);

  useEffect(() => {
    if (!isLoadingdeleteCRUDCategoryById && deleteCRUDCategoryByIdResponse) {
      
      success("CRUD Category deleted successfully.");
      getAllCRUDCategoryList();
    }
  }, [isLoadingdeleteCRUDCategoryById, deleteCRUDCategoryByIdResponse]);

  useEffect(() => {
    if (crudCategoryListData) {
      const formattedData = crudCategoryListData.map((item) => ({
        id: item.id,
        category: item.category,
        subCategory: item.subCategory,
        description: item.description,
        isEditing: false,
        isNew: false
      }));
      setDataSource(formattedData);
    }
  }, [crudCategoryListData]);

  const handleAddRow = () => {
    if (isAdding) {
      error("Please save the current new entry before adding another.");
      return;
    }
    setIsAdding(true);
    setDataSource([
      {
        id: Date.now(),
        category: "Product",
        subCategory: "L1",
        description: "",
        isEditing: true,
        isNew: true
      }, ...dataSource,
    ]);
  };

  const handleChange = (rowId, field, value) => {
    setDataSource((prev) =>
      prev.map((row) => {
        if (row.id !== rowId) return row;
        if (field === "category" && value === "Service") {
          return { ...row, category: value, subCategory: "L1" };
        }
        return { ...row, [field]: value };
      })
    );
  };

  const handleSave = (row) => {
    if (!row.category || !row.subCategory || !row.description.trim()) {
      error("All fields are required.");
      return;
    }

    const request = {
      ProductCrudId: row.isNew ? null : row.id,
      CategoryId: categoryMap[row.category],
      SubCategoryId: row.category === "Service" ? 1 : subCategoryMap[row.subCategory],
      Description: row.description
    };

    if (row.isNew) {
      addCRUDCategory(request);
    } else {
      editCRUDCategory(request);
    }

    if (!row.isNew) {
      setDataSource((prev) =>
        prev.map((item) =>
          item.id === row.id
            ? { ...item, isEditing: false, isNew: false }
            : item
        )
      );
    }
  };

  const handleCancel = (row) => {
    if (row.isNew) {
      setIsAdding(false);
      setDataSource((prev) => prev.filter((item) => item.id !== row.id));
    } else {
      const originalData = crudCategoryListData.map(((item) =>
        item.id === row.id ? { ...item, isEditing: false } : item
      ));
      setDataSource(originalData);
    }
  };

  const handleEdit = (id) => {
    setDataSource((prev) =>
      prev.map((row) =>
        row.id === id
          ? {
              ...row,
              isEditing: true,
              originalRow: { ...row }
            }
          : row
      )
    );
  };

  const handleDelete = (row) => {
    confirm('Delete', "Are you sure you want to delete", 'Yes', 'Cancel')
      .then(id => {
        if (id) {
          deleteCRUDCategoryById(Number(row?.id));
        }
      })
  }

  return (
    <div className="crud-category-list">
      <div className="add-btn-wrapper">
        <Buttons
          buttonText="+ Add New"
          buttonTypeClassName="add-btn"
          onClick={handleAddRow}
        />
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Channel</th>
              <th>Sub Category</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>

          {isCrudCategoryLoading ? (
            <tbody>
              <tr>
                <td colSpan={4}>
                  <div className="flex justify-center items-center min-h-[200px]">
                    <DataLoader />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : dataSource?.length > 0 ? (
            <tbody>
                {dataSource.map((row) => (
                  <tr key={row.id}>

                    <td>
                      {row.isEditing ? (
                        // <select
                        //   value={row.category}
                        //   onChange={(e) =>
                        //     handleChange(row.id, "category", e.target.value)
                        //   }
                        // >
                        //   {categoryOptions.map((opt) => (
                        //     <option key={opt}>{opt}</option>
                        //   ))}
                        // </select>
                        <Select
                          value={categoryOptions.find(opt => opt.value === row.category)}
                          onChange={(selectedOption) =>
                            handleChange(row.id, "category", selectedOption.value)
                          }
                          options={categoryOptions}
                        />
                      ) : (
                        row.category
                      )}
                    </td>

                    <td>
                      {row.isEditing ? (
                        // <select
                        //   value={row.subCategory}
                        //   onChange={(e) =>
                        //     handleChange(row.id, "subCategory", e.target.value)
                        //   }
                        // >
                        //   {(row.category === "Service"
                        //     ? ["L1"]
                        //     : subCategoryOptions
                        //   ).map((opt) => (
                        //     <option key={opt}>{opt}</option>
                        //   ))}
                        // </select>
                        <Select
                          value={subCategoryOptions.find(opt => opt.value === row.subCategory)}
                          onChange={(selectedOption) => handleChange(row.id, "subCategory", selectedOption.value)}
                          options={row.category === "Service" ? subCategoryOptions.filter(opt => opt.value === "L1") : subCategoryOptions}
                        />
                      ) : (
                        row.subCategory
                      )}
                    </td>

                    <td>
                      {row.isEditing ? (
                        <input
                          value={row.description}
                          onChange={(e) =>
                            handleChange(row.id, "description", e.target.value)
                          }
                        />
                      ) : (
                        row.description
                      )}
                    </td>

                    <td>
                      {row.isEditing ? (
                        <>
                          <button
                            className="link-btn"
                            onClick={() => handleSave(row)}
                          >
                            Save
                          </button>

                          <button
                            className="delete-btn"
                            onClick={() => handleCancel(row)}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="link-btn"
                            onClick={() => handleEdit(row.id)}
                          >
                            Edit
                          </button>

                          <button
                            className="delete-btn"
                            onClick={() => handleDelete(row)}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan={4}>
                  <NoRecordFound />
                </td>
              </tr>
            </tbody>
          )}

        </table>
      </div>
    </div>
  );
};

export default CRUDCategoryList;